module.exports = __webpack_public_path__ + "static/media/report.dbee51ef.svg";